import { render, staticRenderFns } from "./AgentPerformanceDashboard.vue?vue&type=template&id=0122acc8&scoped=true"
import script from "./AgentPerformanceDashboard.vue?vue&type=script&lang=js"
export * from "./AgentPerformanceDashboard.vue?vue&type=script&lang=js"
import style0 from "./AgentPerformanceDashboard.vue?vue&type=style&index=0&id=0122acc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0122acc8",
  null
  
)

export default component.exports